import { createStore } from 'vuex'
const keys = { USER: 'user' }
function getUserInfo(state)
{
  if (state.userInfo) return state.userInfo;
  let userInfo = localStorage.getItem(keys.USER);
  if (userInfo)
  {
    state.userInfo = JSON.parse(userInfo);
  }
  return state.userInfo;
}

//超级管理员判定：与后端 UserContext.IsSuperAdmin 同口径（Role_Id=1）。
//通过 getters.isSuperAdmin() 调用，由调用处自行决定是否放行。
function isSuperAdmin(state)
{
  let userInfo = getUserInfo(state);
  console.log('isSuperAdmin:', userInfo);
  return !!(userInfo && (userInfo.Role_Id == 1 || userInfo.Role_Id == '1' || userInfo.role_Id == '1' || userInfo.role_Id == 1));
}
export default createStore({
  state: {
    data: {},
    permission: [],
    isLoading: false,//2020.06.03增加路由切换时加载提示
    userInfo: null
  },
  mutations: {
    setPermission(state, data)
    {  //调用方式 this.$store.commit('setPermission', data)
      if (!data || typeof data != 'object') return;
      if (data instanceof Array)
      {
        state.permission.push(...data);
      } else
      {
        state.permission = data;
      }
    },
    setUserInfo(state, data)
    {
      state.userInfo = data;
      localStorage.setItem(keys.USER, JSON.stringify(data));
    },
    clearUserInfo(state)
    {
      state.permission = [];
      state.userInfo = null;
      localStorage.removeItem(keys.USER);
    },
    test(state)
    {
      return 113344;
    },
    updateLoadingState(state, flag)
    {
      state.isLoading = flag
    }
  }, getters: {
    getPermission: (state) => (path) =>
    {  //调用方式 store.getters.getPermission('sys_User')
      if (!path) return state.permission;
      return state.permission.find(x => x.path == path);
    },
    isSuperAdmin: (state) => () =>
    {  //调用方式 store.getters.isSuperAdmin() —— 超级管理员(Role_Id=1)跳过按钮权限筛选由调用处自行判断
      return isSuperAdmin(state);
    },
    getUserInfo: (state) => () =>
    {
      getUserInfo(state);
      return state.userInfo;
    }, getUserName: (state) => () =>
    {
      getUserInfo(state);
      if (state.userInfo)
      {
        return state.userInfo.userName;
      }
      return '未获取到登陆信息';
    },
    getToken: (state) => () =>
    {
      getUserInfo(state);
      if (state.userInfo)
      {
        return 'Bearer ' + state.userInfo.token;
      }
      return '';
    },
    isLogin: (state) => () =>
    {
      if (getUserInfo(state))
      {
        return true;
      }
      return false;
    },
    isLoading: (state) => () =>
    {
      return state.isLoading;
    },
    data: (state) => () =>
    {
      return state.data;
    },
    getData: (state) => () =>
    {
      return state.data;
    },
  }, actions: {
    setPermission(context, data)
    {
      context.commit('setPermission', data); //调用方式 store.dispatch('push')
    },
    toDo(context)
    {
      return context.Store.m;
    },
    onLoading(context, flag)
    {
      context.commit("updateLoadingState", flag);
    }
  }
})
